import { Position } from '../position/position.js';
import { BOARD_SIZE } from '../rules_spec/constants.js';

export class MaterialEvaluator {
    position: Position;
    private _score: number;

    constructor(position: Position) {
        this.position = position;
        this._score = 0.0;
        this._full_recalc();
    }

    get score(): number {
        return this._score;
    }

    _full_recalc() {
        const pos = this.position;
        let total = 0.0;
        for (let sq_idx = 0; sq_idx < BOARD_SIZE; sq_idx++) {
            const pid = pos.board[sq_idx];
            if (pid === 0) continue;

            const pt = pos.get_piece_type(pid);
            const side = pos.piece_sides[pid];
            const val = pt.value;
            
            if (side === 0) {
                total += val;
            } else {
                total -= val;
            }
        }
        this._score = total;
    }

    apply_move(snapshot: any) {
        const pos = this.position;
        const all_captured: number[] = [];

        const landing = snapshot.captured_landing || 0;
        if (landing !== 0) all_captured.push(landing);

        if (snapshot.captured_path) {
            all_captured.push(...snapshot.captured_path);
        }
        if (snapshot.captured_pids) {
            all_captured.push(...snapshot.captured_pids);
        }

        const mid = snapshot.captured_mid || 0;
        if (mid !== 0) all_captured.push(mid);

        for (const cpid of all_captured) {
            if (cpid === 0) continue;

            const ct_id = snapshot.captured_type_ids[cpid];
            if (ct_id === undefined) continue;

            const ct = pos.piece_types.get(ct_id);
            if (!ct) continue;

            const c_side = snapshot.captured_sides[cpid] || 0;
            if (c_side === 0) {
                this._score -= ct.value; // 先手の駒が取られた
            } else {
                this._score += ct.value; // 後手の駒が取られた
            }
        }
    }

    undo_move(snapshot: any) {
        const pos = this.position;
        const all_captured: number[] = [];

        const landing = snapshot.captured_landing || 0;
        if (landing !== 0) all_captured.push(landing);

        if (snapshot.captured_path) {
            all_captured.push(...snapshot.captured_path);
        }
        if (snapshot.captured_pids) {
            all_captured.push(...snapshot.captured_pids);
        }

        const mid = snapshot.captured_mid || 0;
        if (mid !== 0) all_captured.push(mid);

        for (const cpid of all_captured) {
            if (cpid === 0) continue;

            const ct_id = snapshot.captured_type_ids[cpid];
            if (ct_id === undefined) continue;

            const ct = pos.piece_types.get(ct_id);
            if (!ct) continue;

            const c_side = snapshot.captured_sides[cpid] || 0;
            if (c_side === 0) {
                this._score += ct.value; // 先手の駒が復元
            } else {
                this._score -= ct.value; // 後手の駒が復元
            }
        }
    }

    apply_promotion(pid: number, old_type_id: number, new_type_id: number) {
        const pos = this.position;
        const old_pt = pos.piece_types.get(old_type_id);
        const new_pt = pos.piece_types.get(new_type_id);
        if (!old_pt || !new_pt) return;

        const diff = new_pt.value - old_pt.value;
        const side = pos.piece_sides[pid];

        if (side === 0) {
            this._score += diff; // 先手の駒が価値アップ
        } else {
            this._score -= diff; // 後手の駒が価値アップ
        }
    }

    undo_promotion(pid: number, old_type_id: number, new_type_id: number) {
        const pos = this.position;
        const old_pt = pos.piece_types.get(old_type_id);
        const new_pt = pos.piece_types.get(new_type_id);
        if (!old_pt || !new_pt) return;

        const diff = new_pt.value - old_pt.value;
        const side = pos.piece_sides[pid];

        if (side === 0) {
            this._score -= diff;
        } else {
            this._score += diff;
        }
    }
}
